require('./mobilemenu.less');

jQuery(function() {

    function updateBaseHeight() {
        let $mobileMenu = $('.mobilemenu');
        let $base = $mobileMenu.closest('body');
        let $baseContent = $base.find('.main-container');

        $mobileMenu.addClass('autoheight');

        if ($mobileMenu.innerHeight() > $baseContent.innerHeight())
            $base.css('min-height', $mobileMenu.innerHeight()+'px');
        $mobileMenu.removeClass('autoheight');
    }
    function createMobileMenu() {
        var $existedMobileMenu = $('.mobilemenu');
        if ($existedMobileMenu.length > 0) return $existedMobileMenu;
        var $mobileMenu = $('<div class="mobilemenu" />');
        var $closeButton = $('<div class="mobilemenu__close-button js-closemobile" />');

        var innerParentText = $('.js-topmenu__main-link--current-inner').text();
        var $innerParent = $('<div class="mobilemenu__menu-head mobilemenu__menu-head--open" />').text(innerParentText);

        var $innerMenu = $('<ul class="mobilemenu__menu mobilemenu__menu--inner js-menu-inner-show" />');

        $('.topmenu__inner-list')
            .find('.topmenu__inner-item')
            .each(function() {
                var $this = $(this);
                if ($this.hasClass('js-topmenu__inner-item--also')) return true;

                var $item = $this.clone();

                /////////////////////////////////////////
                let $dropLiIndex = $('<div class="mobilemenu__item mobilemenu__item_all mobilemenu__item--child" />');
                let menuDrop = $item.find('.topmenu__inner-link').clone();

                menuDrop[0].innerHTML = 'Все товары';
                $dropLiIndex.append(menuDrop);

                if ($item.hasClass('js-topmenu-item-dropdown')) {
                    $item.find('.topmenu__inner-link').removeAttr('href');
                    $item.find('.topmenu__inner-link').addClass('js-mobilemenu-show-children-a');
                }

                let $itemDrop = $item.find('.topmenu__dropdown').clone();
                $item.find('.topmenu__dropdown').remove();
                $itemDrop.append($dropLiIndex);
                $item.append($itemDrop);
                /////////////////////////////////////////

                $item.removeClass('topmenu__inner-item').addClass('mobilemenu__menu-item');

                if ($this.hasClass('hidden')) {
                    $item.addClass('hidden');
                }

                $item.find('.topmenu__lvl4-list').remove();
                $item.find('.topmenu__dropdown').addClass('mobilemenu__list mobilemenu__list--children');
                let $arrowSpan = $('<span class="mobilemenu__link mobilemenu__arrow-icon js-mobilemenu-show-children" />');

                if ($item.hasClass('js-topmenu-item-dropdown')) {
                    $item.append($arrowSpan);
                }

                $item
                    .find('.topmenu__inner-link')
                    .removeClass('topmenu__inner-link')
                    .addClass('mobilemenu__menu-link mobilemenu__link mobilemenu__link--parent js-mobilemenu-show-parent-children');

                $innerMenu.append($item);
            });

        $('.js-topmenu__inner-item--also')
            .find('.topmenu__dropdown-column--lvl2')
            .each(function() {
                var $this = $(this);
                var $item = $this.clone();

                /////////////////////////////////////////
                let $dropLiIndex = $('<div class="mobilemenu__item mobilemenu__item_all mobilemenu__item--child mobilemenu__item_all--lv2" />');
                let menuDrop = $item.find('.topmenu__lvl2-link').clone();

                menuDrop[0].innerHTML = 'Все товары';
                $dropLiIndex.append(menuDrop);

                $item.find('.topmenu__lvl2-link').removeAttr('href');
                $item.find('.topmenu__lvl2-link').addClass('js-mobilemenu-show-children-a');
                /////////////////////////////////////////

                $item.removeClass('topmenu__lvl2-link topmenu__dropdown-column topmenu__dropdown-column--lvl2').addClass('js-topmenu-item-dropdown mobilemenu__menu-item');

                if ($this.hasClass('hidden')) {
                    $item.addClass('hidden');
                }

                $item.find('.topmenu__lvl4-list').remove();

                let $itemList = $('<div class="topmenu__dropdown mobilemenu__list mobilemenu__list--children" />');

                $itemList.append($dropLiIndex);

                $itemList.append($item.find('.topmenu__dropdown-column--lvl3'));
                $item.append($itemList);
                
                let $arrowSpan = $('<span class="mobilemenu__link mobilemenu__arrow-icon js-mobilemenu-show-children" />');
                $item.append($arrowSpan);

                $item
                    .find('.topmenu__lvl2-link')
                    .removeClass('topmenu__lvl2-link')
                    .addClass('mobilemenu__menu-link mobilemenu__link mobilemenu__link--parent js-mobilemenu-show-parent-children');
                $innerMenu.append($item);

            });

        var $ordMenu = $('.js-topmenu__main-list--main').clone();
        $ordMenu.removeClass('topmenu__main-list').addClass('mobilemenu__menu');
        $ordMenu.find('.js-topmenu__main-item--special').remove();
        $ordMenu
            .find('.topmenu__main-item')
            .removeClass('topmenu__main-item')
            .removeClass('topmenu__main-item--mobile')
            .addClass('mobilemenu__menu-item');
        $ordMenu
            .find('.topmenu__main-link')
            .removeClass(
                'topmenu__main-link topmenu__main-link--catalog topmenu__main-link--current js-topmenu__main-link--current-inner topmenu__main-link--ico-phone topmenu__main-link--ico-discount'
            )
            .addClass('mobilemenu__menu-link');

        var $cityBlock = $('.header__city').clone();
        $cityBlock.removeClass('header__city').addClass('city-data-block--all-white mobilemenu__menu-item');
        $cityBlock.find('.city-data-block__content').addClass('mobilemenu__menu-link');
        $cityBlock.find('.city-data-block__phones').remove();

        var $cart = $('.header__cart').clone();
        $cart.removeClass('header__cart mini-cart--responsive').addClass('mini-cart--side');

        $ordMenu.find('.mobilemenu__menu-item').each((i, el) => {
            if ('mobilename' in el.dataset) {
                el.firstElementChild.textContent = el.dataset.mobilename;
            }

            if ('beforelast' in el.dataset) {
                el.parentNode.insertBefore(el, el.parentNode.lastElementChild);
            }

            if ('adviser' in el.dataset) {
                /*global carrotquest*/
                /*if (carrotquest && carrotquest.messenger && carrotquest.messenger._collapsedClick) {
                    el.firstElementChild.onclick = carrotquest.messenger._collapsedClick;
                }*/
            }
        });
        $mobileMenu.append($closeButton);
        $mobileMenu.append($innerParent);
        $mobileMenu.append($innerMenu);
        $mobileMenu.append($ordMenu);
        $mobileMenu.append($cityBlock);
        $mobileMenu.append($cart);

        if (!$cart.hasClass('mini-cart--empty')) {
            var $cartLink = $('.cart-preview')
                .find('.cart-preview__cart-link')
                .clone();
            $cartLink.removeClass().addClass('btn-def btn-def--block btn-def--fullwhite');

            $mobileMenu.append($cartLink);
        }

        var $container = $('.main-container');
        $container.append($mobileMenu);

        return $mobileMenu;
    }

    $('.js-btn-mobilemenu').click(function(e) {
        e.stopPropagation();
        var $container = $(this).closest('.main-container');

        var $mobileMenu = createMobileMenu();

        if ($mobileMenu.hasClass('mobilemenu--shown')) {
            $container.removeClass('main-container--shifted-left');
            $container.css('min-height', '0');
            $mobileMenu.removeClass('mobilemenu--shown');
        } else {
            setTimeout(function() {
                $container.addClass('main-container--shifted-left');
                $mobileMenu.addClass('mobilemenu--shown');
                $mobileMenu.addClass('mobilemenu--autoheight');
                if ($mobileMenu.height() > $container.height())
                    $container.css('min-height', $mobileMenu.height() + 'px');
                $mobileMenu.removeClass('mobilemenu--autoheight');
            }, 25);
        }
    });

    $('.js-btn-mobilesearch').click(function(e) {
        e.stopPropagation();

        var divSearch = $('div.simple-search-form__mobile');
        if (divSearch.length > 0) {
            divSearch.remove();
            $('main.page-content').css('margin-top', 0);
        } else {
            setTimeout(function() {
                $.ajax({
                    url: '/ajax/component/bitrix:search.form/mobile/',
                    data: { PAGE: '/search/' },
                    success: function(response) {
                        if (response['code'] == 200) {
                            var search = $(response['html']);
                            if (search[0].tagName !== 'FONT') {
                                $('header.header > .header__wrapper').append(search);
                                $('main.page-content').css('margin-top', search.outerHeight() + 'px');
                            } else {
                                console.log(search.text());
                            }
                        } else {
                            console.log(response['message']);
                        }
                    }
                });
            }, 25);
        }
    });

    $(document).on('click', '.main-container--shifted-left .container', function(e) {
        e.stopPropagation();
        e.preventDefault();
        var $container = $(this).closest('.main-container');
        var $mobileMenu = $('.mobilemenu');
        $container.removeClass('main-container--shifted-left');
        $container.css('min-height', '0');

        $mobileMenu.removeClass('mobilemenu--shown');
    });

    $(document).on('click', '.js-closemobile', function(e) {
        e.stopPropagation();
        e.preventDefault();
        var $container = $('.main-container.main-container--shifted-left');
        var $mobileMenu = $('.mobilemenu');
        $container.removeClass('main-container--shifted-left');
        $container.css('min-height', '0');

        $mobileMenu.removeClass('mobilemenu--shown');
    });

    $(document).on('click', '.mobilemenu__menu-head', function() {
        var $this = $(this);
        if ($this.hasClass('mobilemenu__menu-head--open')) {
            $this.removeClass('mobilemenu__menu-head--open');
            $this.addClass('mobilemenu__menu-head--close');
            $('.js-menu-inner-show').hide();
        } else {
            $this.removeClass('mobilemenu__menu-head--close');
            $this.addClass('mobilemenu__menu-head--open');
            $('.js-menu-inner-show').show();
        }
    });

    $(document).on('click', '.js-mobilemenu-show-children', function(e) {
        e.preventDefault();

        let $this = $(this);
        let $thisItem = $this.closest('.mobilemenu__menu-item');
        let $children = $thisItem.find('.mobilemenu__list--children');

        if ($children.is(':visible')) {
            $children.slideUp(300, function(){
                updateBaseHeight();
                $this.siblings('.mobilemenu__link--parent').removeClass('mobilemenu__link--opened');
                $this.removeClass('mobilemenu__arrow-icon--opened');
            });

        } else {
            $children.slideDown({
                start: function () {
                    updateBaseHeight();
                    $(this).css({
                        display: "flex"
                    });
                }
            });
            $this.siblings('.mobilemenu__link--parent').addClass('mobilemenu__link--opened');
            $this.addClass('mobilemenu__arrow-icon--opened');
        }

    });

    $(document).on('click', '.js-mobilemenu-show-children-a', function(e) {
        e.preventDefault();
        let $this = $(this);
        let $thisItem = $this.closest('.mobilemenu__menu-item');
        let $children = $thisItem.find('.mobilemenu__list--children');

        if ($children.is(':visible'))
        {
            $children.slideUp(300, function(){
                updateBaseHeight();
                $this.removeClass('mobilemenu__link--opened');
                $this.parent().find('.mobilemenu__arrow-icon').removeClass('mobilemenu__arrow-icon--opened');
            });

        }
        else
        {
            $children.slideDown({
                start: function () {
                    updateBaseHeight();
                    $(this).css({
                        display: "flex"
                    });
                }
            });
            $this.addClass('mobilemenu__link--opened');
            $this.parent().find('.mobilemenu__arrow-icon').addClass('mobilemenu__arrow-icon--opened');
        }


    });
});



// WEBPACK FOOTER //
// ./blocks/mobilemenu/mobilemenu.js